import(/* webpackMode: "eager" */ "/vercel/path0/app/heizung/page.tsx");
